<template>
  <v-flex xs6 sm6 md4 lg3 xl3  @click="itemClicked" class="" style="cursor:pointer">
      <v-card class="item pa-1" ripple >
           <v-img
             :src=thumbnailToShow
             aspect-ratio="1.1"
             contain
             class=""
           ></v-img>
           <v-img contain class="" v-if="item.quantity == 0"
                  :src=soldoutImg
                  style="position: absolute;left: 0;top:0;width:100%; height:100%; z-index: 10;" ></v-img>

           <v-layout nowrap>
             <div style="text-overflow: ellipsis; white-space: nowrap;overflow: hidden ">
               {{ this.item.name }}
             </div>
             <v-spacer></v-spacer>
             {{ itemPriceCurrency }}
           </v-layout>
       </v-card>
    </v-flex>
</template>

<script>
import utils from '../../utils.ts'

export default {
  name: 'ItemTile',
  components: {
  },
  props: ['name', 'item'],
  data () {
    return {
      publicPath: process.env.BASE_URL,
      soldoutImg: '/images/soldOut.png',
      noImg: '/images/noimage.png'
    }
  },
  mounted: function () {

  },
  computed: {
    thumbnailToShow: function () {
      // return 'https://picsum.photos/510/300?random'
      const thumbs = this.item.thumbnails
      for (let i = 0; i < thumbs.length; i++) {
        if (thumbs[i]) {
          return thumbs[i].thumbDownloadURL
        }
      }
      return this.noImg
    },
    itemPriceCurrency: function () {
      return utils.formatCurrency(this.item.price)
    }
  },
  methods: {
    itemClicked: function (itm) {
      console.log('ITEM IS CLICKED')
      this.$emit('itemClicked')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.item {
  margin:10px;

}

</style>
